import { Container } from "react-bootstrap";
import PreCertLinkBanner from "./Shared/Components/PreCertLinkBanner";

export default function UnauthorizedPage() {
    return (
        <header>
               <PreCertLinkBanner/>
            <Container>
                <div>
                    You are not authorized to access this page. If you have questions, please email us at <a  href={"mailTo:credentials@abpn.org?subject=ABPN Account Help"}>credentials@abpn.org</a>.
                </div>
            </Container>
        </header>
    );
}